/* eslint-disable no-undef */
import { getToken } from '../services/Auth';

const url = process.env.REACT_APP_APIBASEURL;

export default class RestUtilities {
  static get(path) {
    return RestUtilities.request('GET', path);
  }

  static delete(path) {
    return RestUtilities.request('DELETE', path);
  }

  static put(path, data) {
    return RestUtilities.request('PUT', path, data);
  }

  static post(path, data) {
    return RestUtilities.request('POST', path, data);
  }

  static postFormData(path, data) {
    return RestUtilities.request('POST', path, data, true);
  }

  static request(method, path, data, isFormData = false) {
    const token = getToken();
    let ok = false;
    let body = data;
    let statusCode = 200;
    let statusText = '';
    const headers = new Headers();
    headers.set('Accept', 'application/json');
    if (token) headers.set('Utopia-Token', token);

    if (!isFormData) {
      headers.set('Content-Type', 'application/json');
      body = JSON.stringify(data);
    } else {
      body = data;
    }

    return fetch(`${url}/${path}`, { method, headers, body })
      .then((response) => {
        ok = response.ok;
        statusCode = response.status;
        statusText = response.statusText;
        const responseContentType = response.headers.get('content-type');
        if (
          responseContentType &&
          responseContentType.indexOf('application/json') !== -1
        ) {
          return response.json();
        }
        return response.text();
      })
      .catch((error) => {
        console.log(error);
        return { ok: false, content: null, errorContent: error, status: 500 };
      })
      .then((responseContent) => {
        const response = {
          ok: ok,
          hasModelErrors: statusCode === 400,
          content: ok ? responseContent : null,
          errorContent: ok ? null : responseContent,
          status: statusCode,
          statusText: statusText,
        };
        return response;
      });
  }
}
